// Messages for operator/CarrierDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.carrier_detail.head': '{name} — Carrier',
  'operator.carrier_detail.back': 'Back to companies',
  'operator.carrier_detail.badge': 'Carrier',
  'operator.carrier_detail.edit': 'Edit',
  'operator.carrier_detail.kpi.shipments': 'Shipments',
  'operator.carrier_detail.kpi.quotes': 'Quotes',
  'operator.carrier_detail.offerings.title': 'Transportation offerings',
  'operator.carrier_detail.offerings.sub':
    'The modes this carrier provides — shipment legs reference exactly one.',
  'operator.carrier_detail.offerings.empty': 'No offerings yet.',
  'operator.carrier_detail.offerings.leg': '{count} leg',
  'operator.carrier_detail.offerings.legs': '{count} legs',
  'operator.carrier_detail.offerings.active_aria': '{mode} active',
  'operator.carrier_detail.offerings.remove_aria': 'Remove {mode}',
  'operator.carrier_detail.offerings.confirm_remove': 'Remove the {mode} offering?',
  'operator.carrier_detail.add.mode': 'Mode',
  'operator.carrier_detail.add.mode_aria': 'Mode',
  'operator.carrier_detail.add.label': 'Label (optional)',
  'operator.carrier_detail.add.label_aria': 'Offering label',
  'operator.carrier_detail.add.label_placeholder': 'e.g. Transpacific service',
  'operator.carrier_detail.add.submit': 'Add offering',
  'operator.carrier_detail.mode.ship': 'Ocean',
  'operator.carrier_detail.mode.air': 'Air',
  'operator.carrier_detail.mode.truck': 'Truck',
  'operator.carrier_detail.mode.train': 'Rail',
}

export const zhTW = {
  'operator.carrier_detail.head': '{name} — 承運商',
  'operator.carrier_detail.back': '返回公司列表',
  'operator.carrier_detail.badge': '承運商',
  'operator.carrier_detail.edit': '編輯',
  'operator.carrier_detail.kpi.shipments': '貨件',
  'operator.carrier_detail.kpi.quotes': '報價',
  'operator.carrier_detail.offerings.title': '運輸服務項目',
  'operator.carrier_detail.offerings.sub':
    '此承運商提供的運輸方式 — 每個貨件航段恰好參照其中一項。',
  'operator.carrier_detail.offerings.empty': '尚無服務項目。',
  'operator.carrier_detail.offerings.leg': '{count} 個航段',
  'operator.carrier_detail.offerings.legs': '{count} 個航段',
  'operator.carrier_detail.offerings.active_aria': '{mode} 啟用',
  'operator.carrier_detail.offerings.remove_aria': '移除 {mode}',
  'operator.carrier_detail.offerings.confirm_remove': '要移除 {mode} 服務項目嗎？',
  'operator.carrier_detail.add.mode': '運輸方式',
  'operator.carrier_detail.add.mode_aria': '運輸方式',
  'operator.carrier_detail.add.label': '標籤（選填）',
  'operator.carrier_detail.add.label_aria': '服務項目標籤',
  'operator.carrier_detail.add.label_placeholder': '例如：跨太平洋航線服務',
  'operator.carrier_detail.add.submit': '新增服務項目',
  'operator.carrier_detail.mode.ship': '海運',
  'operator.carrier_detail.mode.air': '空運',
  'operator.carrier_detail.mode.truck': '卡車',
  'operator.carrier_detail.mode.train': '鐵路',
}
